import { render, staticRenderFns } from "./AgendaToolbarExpanded.vue?vue&type=template&id=533eeb4a"
import script from "./AgendaToolbarExpanded.vue?vue&type=script&setup=true&lang=ts"
export * from "./AgendaToolbarExpanded.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports